import {
  SETUP,
  PRODUCT_LIST,
  WAREHOUSE_LIST,
  VENDOR_LIST,
  CATEGORY_LIST,
  SUB_CATEGORY_LIST,
  MASTER_DATA_LIST,
  UOM_LIST,
  SUPPLIER,
  APPROVAL_WORKFLOW,
  ITEM_CODE_SETTINGS,
} from '@constants/internal-route.constant';
import { ROUTE_CODES } from '@constants/route-codes.constant';
import { IAppRoutes } from '@interface/common.interface';
import { lazy } from 'react';

export const SetupRoutes: IAppRoutes = {
  link: SETUP,
  routeCode: ROUTE_CODES.POS_SETUP,
  childrens: [
    {
      link: UOM_LIST,
      routeCode: ROUTE_CODES.SETUP_UOM,
      element: lazy(() => import('@modules/setup/Uom')),
    },
    {
      link: PRODUCT_LIST,
      routeCode: ROUTE_CODES.SETUP_PRODUCT,
      element: lazy(() => import('@modules/setup/Products')),
    },
    {
      link: CATEGORY_LIST,
      routeCode: ROUTE_CODES.SETUP_CATEGORY,
      element: lazy(() => import('@modules/setup/Category')),
    },
    {
      link: SUB_CATEGORY_LIST,
      routeCode: ROUTE_CODES.SETUP_SUB_CATEGORY,
      element: lazy(() => import('@modules/setup/SubCategory')),
    },
    {
      link: MASTER_DATA_LIST,
      routeCode: ROUTE_CODES.SETUP_MASTER_DATA,
      element: lazy(() => import('@modules/setup/MasterData')),
    },
    {
      link: VENDOR_LIST,
      routeCode: ROUTE_CODES.SETUP_VENDOR,
      element: lazy(() => import('@modules/setup/Vendor')),
    },
    {
      link: APPROVAL_WORKFLOW,
      routeCode: ROUTE_CODES.SETUP_APPROVAL_WORKFLOW,
      element: lazy(() => import('@modules/setup/approval-workflow')),
    },
    {
      link: ITEM_CODE_SETTINGS,
      routeCode: ROUTE_CODES.SETUP_ITEM_CODE_CONFIG,
      element: lazy(() => import('@modules/setup/ItemCodeSettings')),
    },
    {
      link: WAREHOUSE_LIST,
      routeCode: ROUTE_CODES.SETUP_WAREHOUSE,
      element: lazy(() => import('@modules/setup/Warehouse')),
    },
    {
      link: SUPPLIER,
      routeCode: ROUTE_CODES.SETUP_SUPPLIER,
      element: lazy(() => import('@modules/setup/Supplier')),
    },
  ],
};
